import { inject, Injectable } from "@angular/core";
import { getAuth } from "@angular/fire/auth";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { getApps, initializeApp } from "firebase/app";
import { environment } from "../../../environments/environment";
import { PathService } from "../services/auth/path.service";

@Injectable({ providedIn: "root" })
export class LoginGuard implements CanActivate {
  // #region Constructors (1)

  constructor(
    private router: Router,
    private pathService: PathService
  ) {}

  // #endregion Constructors (1)

  // #region Public Methods (2)

  public async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {

    const apps = getApps();
    if (apps.length === 0)
    {
      initializeApp(environment.firebase);
    }

    if (getAuth().currentUser)
    {
      this.router.navigateByUrl(this.pathService.getPath());
      return Promise.resolve(false);
    }

    return Promise.resolve(true);
  }
  // #endregion Public Methods (2)
}

export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const guard = inject(LoginGuard);
  return guard.canActivate(route, state);
};
